import angular from 'angular';
// /* global angular */
/* eslint-disable */
export default function editEmergencyProcedureDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  richTextEditorService,
  loaderService,
  bcpDataService,
) {
  const vm = this;

  vm.newProcedure = angular.copy(vm.procedure);

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleFormSubmit = _handleFormSubmit;

  vm.bodyRteOptions = {
    height: 400,
    tokenAttrNames: ['pm-variable', 'pm-endnote'], // Required by richTextEditor to allow these html attributes
    charCounterMax: 4500,
  };
  vm.tokens = {
    variables: [],
    endnotes: [],
    getToken(type, tag) {
      let key;
      switch (type) {
        case 'pm-variable':
          key = 'variables';
          break;
        case 'pm-endnote':
          key = 'endnotes';
          break;
        default:
          key = 'variables';
      }
      const collection = this[key];
      return collection.find(item => item.tag === tag);
    },
    hasData: false,
  };

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    if(vm.newProcedure){
      vm.tokens.hasData=true;
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.editPandemicPlanProcedureDialog);
  }

  function _handleFormSubmit() {
    loaderService.showViewLoader = true;

    vm.procedure.assessmentId = vm.assessmentId;
    vm.newProcedure.assessmentId = vm.assessmentId;
    vm.newProcedure.pandemicInformation = richTextEditorService.getContent('rteBodyPandemicPlanProcedures');
    bcpDataService.savePandemicPlanProcedures(vm.newProcedure).then(() => {
      alerts.success('The pandemic plan procedures have been saved successfully.');

      $rootScope.$broadcast('refreshBCPAssessments');
      if (vm.saveType === 'saveAndClose') {
        _handleCloseDialog();
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

editEmergencyProcedureDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'richTextEditorService',
  'loaderService',
  'bcpDataService'
];
